export const MAX_FILE_SIZE = 8;
export const MAX_FILES = 8;
